// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"a--z"};